import styled from 'styled-components';
import Carousel from 'antd/es/carousel';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .setur-slick-dots {
    display: none !important;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    .setur-slick-dots {
      display: block !important;
    }
    .setur-carousel .slick-dots li button {
      height: 8px !important;
      width: 8px !important;
      border-radius: 50% !important;
      z-index: 2;
    }

    .setur-carousel .slick-dots li {
      margin-inline: 0;
      margin-right: 8px;
      width: 8px;
    }
  }

  & > .carouselWrapper {
    height: 100%;
  }
`;

export const AdvertisementWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  width: fit-content !important;
  height: fit-content !important;
  z-index: 9;
  padding: 4px 10px;
  background-color: ${({ theme }) => theme.palette.lightClearBlue};
`;
export const AdvertisementText = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const SecureLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
  width: fit-content !important;
  height: fit-content !important;
  z-index: 9;
`;

export const SeturLogoWrapper = styled.div`
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 12px;
  left: 10px;
  width: auto !important;
  height: fit-content !important;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    bottom: 10px;
  }
`;

export const StyledCarousel = styled(Carousel)<{ width?: string }>`
  &&& {
    cursor: pointer;
    width: ${({ width }) => width || '244px'};

    .slick-list,
    .slick-track,
    .slick-slide,
    .slick-slide > div {
      height: 100%;
    }

    .setur-carousel {
      height: 100% !important;
    }

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
    }
  }
`;
export const PrevIcon = styled.button`
  cursor: pointer;
  border: none;
  position: absolute;
  z-index: 2;
  border-radius: 8px;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  max-width: fit-content;
  background-color: ${({ theme }) => theme.palette.grey200} !important;
  padding: 0;
  box-shadow: none !important;
`;
export const NextIcon = styled.button`
  cursor: pointer;
  border: none;
  position: absolute;
  z-index: 2;
  border-radius: 8px;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  max-width: fit-content;
  background-color: ${({ theme }) => theme.palette.grey200} !important;
  padding: 0;
  box-shadow: none !important;
`;

export const IconWrapper = styled.div`
  max-width: fit-content;
  padding: 10px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.grey200} !important;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  border-radius: 8px;
`;

export const GalleryButton = styled.div`
  cursor: pointer;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  width: 54px;
  max-width: 62px;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: ${({ theme }) => theme.palette.grey200};
  border-radius: 8px;
  bottom: 12px;
  right: 12px;
`;

export const GalleryCount = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  margin-left: 6px;
`;

export const SeturVideoWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 100;
`;
